import { AnyObject } from '@data-driven-forms/react-form-renderer/dist/cjs/common';
import { ConditionDefinition } from '@data-driven-forms/react-form-renderer';

import { FIELD_NAMES, StepNames } from '../..';
import {
  DBFormSchema,
  fieldCheckboxSection,
  fieldDateSection,
  fieldRadioSection,
  headerSection
} from '../field-helpers';
const { orderInfoFields, clinicalFields } = FIELD_NAMES;

export const orderInfoTabFields = (schema: DBFormSchema, nextStep?: StepNames | AnyObject) => {
  const orderInfoTab = schema?.order_info_tab;

  if (!orderInfoTab || orderInfoTab?.hideTab) return null;

  return {
    title: orderInfoTab?.label ?? 'LEQVIO ORDER INFORMATION',
    name: StepNames.ORDER_INFORMATION,
    nextStep: orderInfoTab?.nextStep ?? nextStep,
    fields: [
      headerSection(schema?.order_info_header?.label, schema?.order_info_header),

      fieldRadioSection(
        orderInfoFields.orderInfoServiceCenterLabel,
        schema?.[orderInfoFields.orderInfoServiceCenterLabel],
        {
          sizes: { md: 12 }
        }
      ),

      fieldCheckboxSection(orderInfoFields.orderInfoValidityText, schema?.[orderInfoFields.orderInfoValidityText], {
        sizes: { md: 12 },
        options: schema?.order_info_validity_text?.options,
        ...hasOrderInfoServiceCenterCondition
      }),
      fieldDateSection(clinicalFields.injectionDate, schema?.[orderInfoFields.orderInfoInjectionDate], {
        sizes: { md: 4 },
        condition: [
          {
            when: orderInfoFields.orderInfoServiceCenterLabel,
            is: (value: string[]) => value?.includes('yes')
          },
          {
            when: orderInfoFields.orderInfoValidityText,
            is: (value: string[]) => value?.includes('Maintenance dose')
          }
        ]
      })
    ].filter(Boolean)
  };
};

export const hasOrderInfoServiceCenterCondition: { condition: ConditionDefinition } = {
  condition: {
    when: orderInfoFields.orderInfoServiceCenterLabel,
    is: 'yes'
  }
};
